// extracted by mini-css-extract-plugin
export default {"container":"ModuleTests_container__g-8oa","tests":"ModuleTests_tests__USE80"};